import './VisionSection.css';
import familyTasks from './../../assets/family_mobile.jpg';
import { Link } from 'react-router-dom';
import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import { isIOS } from '../../hooks/isIos';

export function VisionSection() {
	const ref = useRef(null);
	const marginValue = isIOS() ? '0px' : '-350px';
	const isInView = useInView(ref, { once: true, margin: marginValue });

	return (
		<section className='vision-section' ref={ref}>
			<motion.div
				className='vision-inner'
				initial={{ opacity: 0, y: 40 }}
				animate={isInView ? { opacity: 1, y: 0 } : {}}
				transition={{ duration: 0.8, ease: 'easeOut' }}
			>
				{/* Text-Spalte */}
				<motion.div
					className='vision-text'
					initial={{ opacity: 0, x: -30 }}
					animate={isInView ? { opacity: 1, x: 0 } : {}}
					transition={{ delay: 0.2, duration: 0.6 }}
				>
					<h1>Die <span style={{ color: '#6C5CE7' }}>Vision</span> von Erledix</h1>
					<p className='vision-lead'>
						Erledix ist mehr als eine ToDo-App – es ist unsere Mission, das
						Familienleben entspannter, fairer und digitaler zu gestalten.
					</p>
					<p>
						Wir glauben daran, dass Organisation in Familien nicht mit Zetteln und
						Streit verbunden sein muss. Deshalb möchten wir mit Erledix ein digitales
						Zuhause für Aufgaben schaffen, in dem sich alle Familienmitglieder
						verstanden und eingebunden fühlen – egal ob Eltern, Kinder oder Mitbewohner.
					</p>
					<p>
						Mit Erledix möchten wir die täglichen Herausforderungen des Familienalltags
						einfacher machen – damit mehr Zeit für das bleibt, was wirklich zählt.
					</p>
										<motion.div
						initial={{ opacity: 0, y: 20 }}
						animate={isInView ? { opacity: 1, y: 0 } : {}}
						transition={{ delay: 0.6, duration: 0.4 }}
					>
						<Link to='/beta-signup' className='cta-button'>
							Jetzt Beta-Zugang sichern
						</Link>
					</motion.div>
				</motion.div>

				{/* Bild-Spalte
				<motion.div
					className='vision-image-container'
					initial={{ opacity: 0, x: 30, scale: 0.95 }}
					animate={isInView ? { opacity: 1, x: 0, scale: 1 } : {}}
					transition={{ delay: 0.4, duration: 0.6 }}
				>
					<img src={familyTasks} alt='familytasks' className='vision-image' />
					<motion.div
						initial={{ opacity: 0, y: 20 }}
						animate={isInView ? { opacity: 1, y: 0 } : {}}
						transition={{ delay: 0.6, duration: 0.4 }}
					>
						<Link to='/beta-signup' className='cta-button'>
							Jetzt Beta-Zugang sichern
						</Link>
					</motion.div>
				</motion.div> */}
			</motion.div>
		</section>
	);
}
